var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ajuda-app",on:{"scroll":_vm.scroll}},[_c('ajuda-header'),_c('div',{staticClass:"ajuda-page"},[_c('router-view')],1),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_vm._v(" Portal de ajuda e documentação do ERP da Suporte Leilões"),_c('br'),_c('a',{attrs:{"href":"https://www.suporteleiloes.com.br"}},[_vm._v("www.suporteleiloes.com.br")])])
}]

export { render, staticRenderFns }